// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-list {\n  display: flex;\n}\n.icon-list > button.btnx {\n  flex: 1;\n}\n.icon-list > button.btnx > div {\n  font-family: 'proximaNova', Arial, Helvetica, sans-serif;\n}\n.icon-list > button.btnx + button.btnx {\n  margin-left: 4px;\n}\n.icon-list.column-list {\n  flex-direction: column;\n  max-height: 300px;\n  overflow-y: auto;\n}\n.icon-list.column-list > button.btnx + button.btnx {\n  margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
